// extracted by mini-css-extract-plugin
export default {"custom-dropdown":"InfoProvider_custom-dropdown__+XdnV","item":"InfoProvider_item__0F26l"};